import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <div className="pt-24 pb-16">
        {/* Hero Section */}
        <section className="bg-gray-50 py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl font-serif mb-6">About We.Tour</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              We.Tour is an innovative platform that connects travelers with trained local college student tour guides. We believe in creating opportunities for students while providing authentic, affordable, and memorable tour experiences.
            </p>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-serif mb-6">Our Mission</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Our mission is to revolutionize the tour guide industry by empowering college students to share their knowledge and passion for their campus and local area while earning income. We provide a platform where education meets entrepreneurship.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Every guide is trained and approved by professional tour guides in their respective regions, ensuring you receive high-quality, knowledgeable, and engaging tours.
                </p>
              </div>
              <div className="rounded-lg overflow-hidden shadow-lg">
                <img 
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800" 
                  alt="Students" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl font-serif text-center mb-16">Our Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <h3 className="text-2xl font-serif mb-4">Education First</h3>
                <p className="text-gray-600">We prioritize knowledge and continuous learning, ensuring our guides are well-informed and passionate about their campus and local history and culture.</p>
              </div>
              <div className="text-center">
                <h3 className="text-2xl font-serif mb-4">Affordability</h3>
                <p className="text-gray-600">We believe great experiences shouldn't break the bank. Our student guides offer competitive pricing without compromising quality.</p>
              </div>
              <div className="text-center">
                <h3 className="text-2xl font-serif mb-4">Authenticity</h3>
                <p className="text-gray-600">Local students provide genuine insights and perspectives that traditional tour companies simply can't match.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Become a Guide CTA Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-serif mb-6">Become a Part-Time Local Tour Guide</h2>
            <p className="text-xl text-gray-600 mb-8">
              Are you a college student who loves your campus? Join We.Tour and share your knowledge with visitors while earning money!
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="p-4">
                <div className="text-3xl mb-2">💰</div>
                <h4 className="font-semibold mb-2">Earn Money</h4>
                <p className="text-sm text-gray-500">Set your own rates and schedule</p>
              </div>
              <div className="p-4">
                <div className="text-3xl mb-2">🎓</div>
                <h4 className="font-semibold mb-2">Build Skills</h4>
                <p className="text-sm text-gray-500">Develop leadership and communication</p>
              </div>
              <div className="p-4">
                <div className="text-3xl mb-2">🤝</div>
                <h4 className="font-semibold mb-2">Help Others</h4>
                <p className="text-sm text-gray-500">Guide future students to your school</p>
              </div>
            </div>
            <a 
              href="/explore-schools" 
              className="inline-block bg-black text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
            >
              Apply to Be a Guide →
            </a>
          </div>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default AboutUs;